module.exports = __webpack_public_path__ + "static/bg1-7e5efd35418e658e3e60210d34042bb5.svg";